export default function (selector) {
  const element = document.querySelector(selector)
  if (!element) {
    throw new Error(`${element} not found`)
  }

  return {
    addClass(className) {
      if (element) {
        element.classList.add(className)
      }
    },

    removeClass(className) {
      if (element) {
        element.classList.remove(className)
      }
    },
  }
}
